/**
 * Recently Played entries keyed by a Qobuz TRACK id (Paul McGowan, Oct 26 2026:
 * Zoot Sims saved as 54335098 instead of album oi3ttwef8h75a).
 */
import { useRecentAlbumsStore, normalizeRecentAlbumId, dedupeRecentAlbumsById, saveToLocalStorage as saveRecentAlbumsToLocalStorage } from './recentAlbumsStore';
import { qobuzStaticCoverUrl } from '../utils/qobuzStaticCoverUrl';
import { diagnosticLog } from '../utils/diagnosticLogger';

/** A track's own id never stands in for its album id. */
export function withoutOwnTrackId(albumId: string, track: Record<string, unknown>, source: string, isRadio: boolean): string {
  if (isRadio || !albumId) return albumId;
  const own = [track.id, track.trackId, track.qobuzTrackId, track.serviceTrackId]
    .map((v) => normalizeRecentAlbumId(v as string | undefined, source));
  return own.includes(albumId) ? '' : albumId;
}

/** Re-key locally, then pull the server list — mycelium re-keys its stored row on list (server wins). */
export function rekeyRecentAlbum(badId: string, realId: string): void {
  const bad = String(badId || '').trim();
  const real = normalizeRecentAlbumId(realId, 'qobuz');
  const store = useRecentAlbumsStore;
  const albums = store.getState().albums;
  if (!bad || !real || bad === real || !albums.some((a) => a.album_id === bad)) return;
  const updated = dedupeRecentAlbumsById(albums.map((a) => (a.album_id === bad
    ? { ...a, album_id: real, source: 'qobuz', artwork_url: qobuzStaticCoverUrl(real) || a.artwork_url }
    : a)));
  store.setState({ albums: updated });
  saveRecentAlbumsToLocalStorage(updated);
  diagnosticLog('info', 'navigation', `[recents] rekey track id ${bad} -> ${real}`, { album_id: bad, resolved_album_id: real });
  void store.getState().fetchRecent(true);
}
